import { render } from "./AtendimentoAcompanhamento.vue?vue&type=template&id=5333f7c2"
import script from "./AtendimentoAcompanhamento.vue?vue&type=script&lang=js"
export * from "./AtendimentoAcompanhamento.vue?vue&type=script&lang=js"

import exportComponent from "/builds/ssp/csmpmview/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__